// Libraries
import { Icon, IconProps } from '@chakra-ui/react';

/**
 * Component that renders the Reset Icon.
 * @param {IconProps} props - The IconProps for the ResetIcon component.
 * @returns {ReactElement} The ResetIcon component.
 */
export const ResetIcon = (props: IconProps) => {
  const { color = 'currentcolor', ...rest } = props;
  return (
    <Icon viewBox='0 0 8 8' color={color} {...rest} id='reset-icon'>
      <path
        d='M0.330403 0.330403L1.17177 1.17177C1.89556 0.447855 2.8954 0 3.99998 0C6.20419 0 8.00161 1.79879 8 4.00298C7.99839 6.21076 6.20815 8 4 8C2.96894 8 2.029 7.60989 1.31971 6.96923C1.23724 6.89474 1.23337 6.76663 1.31194 6.68805L1.63029 6.36969C1.70284 6.29714 1.81985 6.29252 1.89644 6.36079C2.45505 6.85881 3.19185 7.16129 4 7.16129C5.74711 7.16129 7.16129 5.74739 7.16129 4C7.16129 2.25289 5.74739 0.83871 4 0.83871C3.1264 0.83871 2.33618 1.19231 1.76429 1.76429L2.63732 2.63734C2.75926 2.75927 2.6729 2.96774 2.50047 2.96774H0.193548C0.0866613 2.96774 0 2.88108 0 2.77419V0.467274C0 0.294839 0.208484 0.208484 0.330403 0.330403Z'
        fill='currentColor'
      />
    </Icon>
  );
};
